import React, { useEffect, useRef } from 'react';

const SPARKLE_COLORS = [
  'rgba(96,165,250,0.8)', // blue-400
  'rgba(59,130,246,0.7)', // blue-600
  'rgba(236, 233, 254, 0.7)', // indigo-50
  'rgba(255,255,255,0.8)', // white
];

function randomBetween(a, b) {
  return a + Math.random() * (b - a);
}

function SparkleCursor() {
  const sparkleRef = useRef([]);
  const containerRef = useRef();
  const isActiveRef = useRef(true);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    
    let sparkles = [];

    function addSparkle(x, y) {
      if (!isActiveRef.current) return;
      
      const size = randomBetween(6, 14);
      const color = SPARKLE_COLORS[Math.floor(Math.random() * SPARKLE_COLORS.length)];
      const sparkle = document.createElement('div');
      sparkle.className = 'sparkle-cursor-sparkle';
      sparkle.style.position = 'fixed';
      sparkle.style.left = `${x - size / 2}px`;
      sparkle.style.top = `${y - size / 2}px`;
      sparkle.style.width = `${size}px`;
      sparkle.style.height = `${size}px`;
      sparkle.style.borderRadius = '50%';
      sparkle.style.pointerEvents = 'none';
      sparkle.style.background = `radial-gradient(circle at 60% 40%, ${color} 0%, transparent 80%)`;
      sparkle.style.opacity = '1';
      sparkle.style.zIndex = '9999';
      sparkle.style.transition = 'opacity 0.7s linear, transform 0.7s linear';
      sparkle.style.transform = `scale(${randomBetween(0.7, 1.2)}) translateY(${randomBetween(-8, 8)}px)`;
      
      container.appendChild(sparkle);
      
      setTimeout(() => {
        if (isActiveRef.current && sparkle.parentNode) {
          sparkle.style.opacity = '0';
          sparkle.style.transform += ' scale(1.5)';
        }
      }, 10);
      
      setTimeout(() => {
        if (isActiveRef.current && sparkle.parentNode) {
          try {
            sparkle.parentNode.removeChild(sparkle);
            // Remove from sparkles array
            const index = sparkles.indexOf(sparkle);
            if (index > -1) {
              sparkles.splice(index, 1);
            }
          } catch (e) {
            // Element already removed, ignore
          }
        }
      }, 700);
      
      sparkles.push(sparkle);
      
      // Limit the number of sparkles
      if (sparkles.length > 40) {
        const old = sparkles.shift();
        if (old && old.parentNode) {
          try {
            old.parentNode.removeChild(old);
          } catch (e) {
            // Element already removed, ignore
          }
        }
      }
    }

    function onMove(e) {
      if (!isActiveRef.current) return;
      
      if (e.touches) {
        const t = e.touches[0];
        addSparkle(t.clientX, t.clientY);
      } else {
        addSparkle(e.clientX, e.clientY);
      }
    }
    
    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    
    return () => {
      isActiveRef.current = false;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('touchmove', onMove);
      
      // Clean up remaining sparkles
      sparkles.forEach(sparkle => {
        if (sparkle && sparkle.parentNode) {
          try {
            sparkle.parentNode.removeChild(sparkle);
          } catch (e) {
            // Element already removed, ignore
          }
        }
      });
      sparkles = [];
    };
  }, []);

  return <div ref={containerRef} style={{ pointerEvents: 'none', position: 'fixed', inset: 0, zIndex: 9999 }} aria-hidden="true" />;
}

export default SparkleCursor; 